import api from './api'

export const getLayoutsByProduct = async (productId) => {
  if (!productId) return []
  const response = await api.get(`/layouts/products/${productId}/layouts`)
  return response.data
}
